import { formatDistanceToNow } from "date-fns";
import { es } from "date-fns/locale";
import { Card, CardContent } from "../ui/card";
import { PriorityBadge, StatusBadge } from "./ticketBadges";
import type { Ticket } from "../../services/ticketsService";

interface TicketCardProps {
  ticket: Ticket;
  showReporter?: boolean;
  onClick: () => void;
}

export function TicketCard({ ticket, showReporter, onClick }: TicketCardProps) {
  return (
    <Card
      className="cursor-pointer hover:border-primary/50 transition-colors"
      onClick={onClick}
    >
      <CardContent className="py-3 px-4 flex items-center justify-between gap-3">
        <div className="min-w-0">
          <div className="font-medium truncate">{ticket.title}</div>
          <div className="text-xs text-muted-foreground truncate">
            {ticket.module && (
              <>
                {ticket.module}
                {ticket.section && <> · {ticket.section}</>}
                {" — "}
              </>
            )}
            {showReporter && <>{ticket.reporter_name || ticket.reporter_email} · </>}
            {formatDistanceToNow(new Date(ticket.created_at), { addSuffix: true, locale: es })}
          </div>
        </div>
        <div className="flex items-center gap-2 shrink-0">
          <PriorityBadge priority={ticket.priority} />
          <StatusBadge status={ticket.status} />
        </div>
      </CardContent>
    </Card>
  );
}
